<template>
  <div class="MessageRooms">
    <div class="buttonRow">
      <select
        name="messageSelection"
        class="messageSelection"
        v-model="messageType"
        v-if="!$isSingleLanguage"
      >
        <option
          v-for="selectionType in messageSelectiontypes"
          :key="selectionType.name"
          :value="selectionType.name"
        >
          {{ selectionType.name }}
        </option>
      </select>
      <select
        name="messageSelection"
        class="messageSelection"
        v-model="messageType"
        v-else
      >
        <option
          v-for="selectionType in messageSelectiontypes.slice(0, 2)"
          :key="selectionType.name"
          :value="selectionType.name"
        >
          {{ selectionType.name }}
        </option>
      </select>
      <button-global
        text="DESELECT ALL GUESTS"
        type="positive"
        size="medium"
        @eventPassed="deselectAll"
      ></button-global>
    </div>
    <div class="scrollListBox">
      <div
        v-for="room in computedRoomsWithInformation"
        class="selectionRow"
        :key="room.sortingNumber"
      >
        <div class="container">
          <input
            type="checkbox"
            :value="room"
            v-model="selectedGuests"
            checked
          />
          <span class="checkmark"></span>
          <p class="remove--margin-bottom">
            {{ room.roomnumber }} - {{ room.guestname }}
            {{ room.guestlastname }}
          </p>
          <img
            class="flagImage"
            :src="`https://www.countryflagicons.com/FLAT/32/${
              room.language === 'EN' ? 'GB' : room.language
            }.png`"
            v-if="room.language && room.language !== ''"
          />
          <v-icon
            name="question-circle"
            scale="1.5"
            style="margin-left: 10px"
            color="#D95D5D"
            v-else
          ></v-icon>
          <span
            class="nationalityInitials"
            v-if="room.language !== '' && room.language !== 'none'"
            >{{ room.language }}</span
          >
          <div class="contactInformation">
            <v-icon
              name="phone"
              scale="1.8"
              :color="
                isContactInfoValidOld(room.phone)
                  ? contactValidColor
                  : contactInvalidColor
              "
            ></v-icon>
            <v-icon
              name="envelope"
              scale="1.8"
              :color="
                isEmailValid(room.email)
                  ? contactValidColor
                  : contactInvalidColor
              "
            ></v-icon>
            <span
              class="tooltip"
              :class="
                isContactInfoValidOld(room.phone) || isEmailValid(room.email)
                  ? 'contactPresent'
                  : 'contactMissing'
              "
            >
              {{ contactInfoState(room.email, room.phone) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import bus from "@/bus.js";

export default {
  name: "MultiMessageRooms",
  components: {
    ButtonGlobal,
  },
  props: {
    occupiedRooms: Array,
  },
  data() {
    return {
      selectedGuests: [],
      messageType: "MANUAL SELECTION",
      messageSelectiontypes: [
        {
          name: "MANUAL SELECTION",
        },
        {
          name: "SELECT ALL GUESTS",
        },
        {
          name: "SELECT NATIVE GUESTS",
        },
        {
          name: "SELECT FOREIGN GUESTS",
        },
      ],
      contactValidColor: "#49A39C",
      contactInvalidColor: "#E8E8E8",
      allIsAlreadySelected: false,
    };
  },
  watch: {
    messageType(newValue) {
      switch (newValue) {
        case "MANUAL SELECTION":
          return this.deselectAll();
        case "SELECT ALL GUESTS":
          return this.selectAll();
        case "SELECT NATIVE GUESTS":
          return this.selectNative();
        case "SELECT FOREIGN GUESTS":
          return this.selectForeign();
        default:
          return this.selectAll();
      }
    },
    selectedGuests() {
      if (this.selectedGuests.length === 0) {
        bus.$emit("selectedGuestChange", true);
      } else {
        bus.$emit("selectedGuestChange", false);
        this.$emit("selectedGuestObject", this.selectedGuests);
      }
    },
  },
  deactivated() {
    this.$emit("selectionChange", this.messageType);
  },
  computed: {
    computedRoomsWithInformation() {
      return this.occupiedRooms;
    },
  },
  methods: {
    selectAll() {
      if (!this.allIsAlreadySelected) {
        for (var selection in this.computedRoomsWithInformation) {
          this.selectedGuests.push(
            this.computedRoomsWithInformation[selection]
          );
        }
        this.allIsAlreadySelected = true;
      } else {
        return;
      }
    },
    selectNative() {
      this.deselectAll();
      for (var selection in this.computedRoomsWithInformation) {
        if (
          this.computedRoomsWithInformation[selection].language ==
          this.$hotelLocationInitals
        ) {
          this.selectedGuests.push(
            this.computedRoomsWithInformation[selection]
          );
        }
      }
    },
    selectForeign() {
      this.deselectAll();
      for (var selection in this.computedRoomsWithInformation) {
        if (
          this.computedRoomsWithInformation[selection].language !=
          this.$hotelLocationInitals
        ) {
          this.selectedGuests.push(
            this.computedRoomsWithInformation[selection]
          );
        }
      }
    },
    deselectAll() {
      this.selectedGuests = [];
      this.allIsAlreadySelected = false;
    },
    contactInfoState(emailState, phoneState) {
      if (
        this.isEmailValid(emailState) &&
        this.isContactInfoValidOld(phoneState)
      ) {
        return "SMS/E-Mail are present";
      } else if (this.isEmailValid(emailState)) {
        return "Only E-mail is present";
      } else if (this.isContactInfoValidOld(phoneState)) {
        return "Only Phone is present";
      } else {
        return "No Information is present";
      }
    },
    isContactInfoValidOld(contactData) {
      return (
        contactData !== "Blacklisted" &&
        contactData !== "Already in use" &&
        contactData !== "Invalid" &&
        contactData !== "Nothing from PMS" &&
        contactData !== "none" &&
        contactData !== ""
      );
    },
    isEmailValid(emailInput) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      return re.test(emailInput);
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.MessageRooms {
  width: 100%;
  height: 100%;
  max-width: 1060px;
  margin: 0 auto;
  position: relative;
  padding: 25px 25px 10px 25px;
}
.buttonRow {
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
}
.buttonRow > select {
  background-color: #48b9ba;
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0 10px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  color: white;
}
.scrollListBox {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 84%;
}

.selectionRow {
  text-align: left;
  width: 100%;
}
.container {
  display: flex;
  align-items: center;
  padding-left: 25px;
  width: 100%;
  cursor: pointer;
  text-align: left;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  margin-bottom: 8px;
}
.container .nationalityInitials {
  font-weight: bold;
}
.container .contactInformation {
  position: relative;
  margin-left: 20px;
  display: flex;
  width: 70px;
  justify-content: space-between;
}
.container .contactInformation .tooltip {
  visibility: hidden;
  background-color: #48b9ba;
  width: 220px;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px 5px;
  position: absolute;
  z-index: 1;
  top: -2.5px;
  left: 120%;
  opacity: 0;
  transition: opacity 0.2s;
}

.container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.container .contactInformation .contactPresent {
  background-color: #48b9ba;
}

.container .contactInformation .contactMissing {
  background-color: rgba(214, 80, 74, 0.8);
}

.container .flagImage {
  margin: 0 10px;
}
.container .unknownNat {
  width: 30px;
  margin-left: 10px;
}
/* Hide the browser's default checkbox */
.container input {
  height: 30px;
  width: 90%;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  height: 30px;
  width: 30px;
  border: 2px solid #48b9b2;
  border-radius: 4px;
  margin-right: 10px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #48b9b2;
}
/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}
@media screen and (min-width: 1030px) {
  .scrollListBox {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 90%;
  }
}
@media screen and (max-width: 765px) {
  .MessageRooms {
    width: 100%;
    margin-bottom: 30px;
  }

  .buttonRow {
    flex-direction: column;
  }
  .buttonRow > div {
    margin-top: 10px;
  }
}
</style>
